// assets/zoom-lightbox.js
(() => {
  const root = document;
  const SELECTOR = "[data-zoom-src]";

  const ensureDialog = () => {
    let dialog = root.getElementById("ProductZoomDialog");
    if (dialog) return dialog;

    dialog = root.createElement("dialog");
    dialog.id = "ProductZoomDialog";
    dialog.className = "product__zoom-dialog";
    dialog.innerHTML = `
      <div class="product__zoom-inner" role="document">
        <button class="product__zoom-close" type="button" aria-label="Close zoom">✕</button>
        <img class="product__zoom-img" alt="" />
      </div>
    `;
    root.body.appendChild(dialog);

    const closeBtn = dialog.querySelector(".product__zoom-close");
    closeBtn.addEventListener("click", () => dialog.close());

    // Close when clicking backdrop
    dialog.addEventListener("click", (e) => {
      const rect = dialog.querySelector(".product__zoom-inner").getBoundingClientRect();
      const inBox =
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom;
      if (!inBox) dialog.close();
    });

    return dialog;
  };

  const openZoom = (zoomSrc, alt = "") => {
    const dialog = ensureDialog();
    const img = dialog.querySelector(".product__zoom-img");
    img.src = zoomSrc;
    img.alt = alt || "";
    if (!dialog.open) dialog.showModal();
  };

  // Event delegation (works with sliders / swapped media)
  root.addEventListener("click", (e) => {
    const target = e.target.closest(SELECTOR);
    if (!target) return;

    // Ignore clicks on controls/buttons in the gallery
    if (e.target.closest("button, a")) return;

    e.preventDefault();
    openZoom(target.getAttribute("data-zoom-src"), target.getAttribute("data-zoom-alt") || "");
  });
})();
